import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { catchError, map, of, switchMap, take } from 'rxjs';
import { AuthService } from './auth.service';
import { Store } from '@ngrx/store';
import { selectUserInfo } from '@store/selectors/user.selectors';
import { userLoaded } from '@store/actions/user.actions';
import { CommonService } from 'app/services/common/common.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {

    const commonService = inject(CommonService);
    const store = inject(Store);
    const authService = inject(AuthService);

    return store.select(selectUserInfo).pipe(
        take(1),
        switchMap((user) => {
            if (user) {
                return of(true);
            }

            return authService.check().pipe(
                map((authenticatedUser) => {
                    if (!authenticatedUser) {
                        commonService.logoutImmediately();
                        return false;
                    }

                    store.dispatch(userLoaded({ userInfos: authenticatedUser }));
                    return true;
                }),
                catchError((error: HttpErrorResponse) => {
                    commonService.showSnackBar(
                        getAuthenticationCheckErrorMessage(error),
                        commonService.errorMessage
                    );
                    return of(false);
                }),
            );
        }),
    );
};

const getAuthenticationCheckErrorMessage = (error: HttpErrorResponse): string => {
    const messages: Record<number, string> = {
        403: 'errors.standardErrorMessage403',
        500: 'errors.standardErrorMessage500',
        502: 'errors.standardErrorMessage502',
        504: 'errors.standardErrorMessage504',
    };

    return messages[error.status] ?? 'errors.standardErrorMessage500';
};
